export const FETCH_SUMMARY_FFD_PVT_INIT = 'FETCH_SUMMARY_FFD_PVT_INIT';
export const FETCH_SUMMARY_FFD_PVT_SUCCESS = 'FETCH_SUMMARY_FFD_PVT_SUCCESS';
export const FETCH_SUMMARY_FFD_PVT_FAILURE = 'FETCH_SUMMARY_FFD_PVT_FAILURE';

export const FETCH_SUMMARY_FFD_PVT_TABLE_INIT = 'FETCH_SUMMARY_FFD_PVT_TABLE_INIT';
export const FETCH_SUMMARY_FFD_PVT_TABLE_SUCCESS = 'FETCH_SUMMARY_FFD_PVT_TABLE_SUCCESS';
export const FETCH_SUMMARY_FFD_PVT_TABLE_FAILURE = 'FETCH_SUMMARY_FFD_PVT_TABLE_FAILURE';

export const FETCH_SUMMARY_FFD_PVT_TABLE_COUNT_INIT = 'FETCH_SUMMARY_FFD_PVT_TABLE_COUNT_INIT';
export const FETCH_SUMMARY_FFD_PVT_TABLE_COUNT_SUCCESS = 'FETCH_SUMMARY_FFD_PVT_TABLE_COUNT_SUCCESS';
export const FETCH_SUMMARY_FFD_PVT_TABLE_COUNT_FAILURE = 'FETCH_SUMMARY_FFD_PVT_TABLE_COUNT_FAILURE';

export const FETCH_SUMMARY_FFD_PVT_TABLE_NO_LOADING_INIT = 'FETCH_SUMMARY_FFD_PVT_TABLE_NO_LOADING_INIT';
export const FETCH_SUMMARY_FFD_PVT_TABLE_NO_LOADING_SUCCESS =
  'FETCH_SUMMARY_FFD_PVT_TABLE_NO_LOADING_SUCCESS';
export const FETCH_SUMMARY_FFD_PVT_TABLE_NO_LOADING_FAILURE =
  'FETCH_SUMMARY_FFD_PVT_TABLE_NO_LOADING_FAILURE';

export const FETCH_SUMMARY_FFD_PVT_BPM_INIT = 'FETCH_SUMMARY_FFD_PVT_BPM_INIT';
export const FETCH_SUMMARY_FFD_PVT_BPM_SUCCESS = 'FETCH_SUMMARY_FFD_PVT_BPM_SUCCESS';
export const FETCH_SUMMARY_FFD_PVT_BPM_FAILURE = 'FETCH_SUMMARY_FFD_PVT_BPM_FAILURE';

export const SET_FILTER_SUMMARY_FFD_PVT = 'SET_FILTER_SUMMARY_FFD_PVT';
export const RESET_SUMMARY_FFD_PVT = 'RESET_SUMMARY_FFD_PVT';
export const SET_ACTIVE_STATE_SUMMARY_FFD_PVT = 'SET_ACTIVE_STATE_SUMMARY_FFD_PVT';


// WEBPACK FOOTER //
// ./source/client/actions/summary_ffd_pvt/types.js